import { LinearProgress } from "@material-ui/core";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import Query from "qpr-base/querybuilder/Query";
import React from "react";
import { useQuery } from "react-query";
import Select, { components } from "react-select";
import { ReactComponent as SearchIcon } from "../../../../assets/searchIcon.svg";
import useSelectStyles, { indicatorStyles } from "./Select/themes";
type option = { label: string; value: string };
type ElementType = "kpi" | "project";
type Props = {
  elementType: ElementType;
  label?: string;
  isMulti?: boolean;
  dir?: string;
  placeholder?: string;
  name: string;
  value?: option;
  isSearchable?: boolean;
  isAsync?: boolean;
  options?: option[];
  onChange: (val: any) => any;
};

const DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <SearchIcon />
    </components.DropdownIndicator>
  );
};

const ext = {
  optionsCallback: (options: any) => {},
};

type NavItem = {
  link: string;
  title: string;
  children?: Array<NavItem>;
};

type SelectItem = {
  value: string;
  label: string;
};

const getElements = async (
  modelId: string,
  type: ElementType
): Promise<
  {
    id: string;
    name: string;
    startdate: string;
    enddate: string;
    periodlevel: string;
    "scorecard.name"?: string;
  }[]
> => {
  if (type === "project") {
    return Query(modelId)
      .PROJECT({
        criteria: {
          hasreferencescorecard: "0",
        },
      })
      .attributes("name")
      .fetchValues();
  }
  return Query(modelId)
    .KPI({
      criteria: 'hasreferencescorecard="0" AND scorecard.symbol <> "SCHEMA"',
    })
    .attributes("name", "scorecard.name")
    .fetchValues();
};

const useElements = (modelId: string, type: ElementType) => {
  const ctx = useAppContext();
  return useQuery(`kpis-${modelId}`, async () => {
    return getElements(ctx.fullModelId || "", type);
  });
};

const ElementSelect = (props: Props) => {
  const ctx = useAppContext();
  const classes = useSelectStyles();
  const { label, isSearchable } = props;

  const { data, isLoading } = useElements(ctx.modelId, props.elementType);
  const [searchText, setSearchText] = React.useState("");

  const options = React.useMemo<SelectItem[]>(() => {
    if (data && !isLoading) {
      return data
        .map((item) => {
          const scname = item["scorecard.name"] || "unknown";
          return {
            value: item.id,
            label: `${item.name} [${scname}]`,
          };
        })
        .sort((a, b) => a.label.localeCompare(b.label));
    }
    return [];
  }, [data, isLoading, props.elementType]);

  if (isLoading) {
    return (
      <div
        style={{ width: "100%", height: "2px", padding: "20px 0px 20px 0px" }}
      >
        <LinearProgress />
      </div>
    );
  }

  return (
    <>
      {label !== (null || undefined) ? (
        <p className={classes.label}>{label}</p>
      ) : null}

      <Select
        styles={{
          indicatorsContainer: isSearchable ? indicatorStyles : undefined,
          indicatorSeparator: (base: any) => ({ ...base, display: "none" }),
          control: (base: any) => ({
            ...base,
            height: "43px",
            borderRadius: "6px",
            alignItems: "center",
            cursor: isSearchable ? "text" : "pointer",
          }),
        }}
        options={options}
        components={isSearchable ? { DropdownIndicator } : undefined}
        className={classes.select}
        {...props}
      />
    </>
  );
};

export default ElementSelect;
